export function MiniCartInit() {
  const miniCartButtonQuery = '.wc-block-mini-cart__button';
  const miniCartDrawerQuery = '.wc-block-mini-cart__drawer';
  const miniCartButton = document.querySelector(miniCartButtonQuery);

  /**
   * @type {null | Event}
   */
  let clickedEvent = null;

  /**
   * @param {Event} $event
   */
  const clickAction = ($event) => {
    clickedEvent = $event;
  };

  miniCartButton.addEventListener('click', clickAction);

  const interval = setInterval(() => {
    miniCartButton.dispatchEvent(new Event('mouseover'));
    if (!document.querySelector(miniCartDrawerQuery)) {
      clear();
    }
  }, 300);

  const timeout = setTimeout(() => clear(), 15000);

  const clear = () => {
    clearInterval(interval);
    clearTimeout(timeout);
    miniCartButton.removeEventListener('click', clickAction);
    if (clickedEvent) {
      setTimeout(document.querySelector(miniCartButtonQuery).click(), 150);
    }
  }

}
